import { Skeleton } from '@/src/components/ui/skeleton';

const ProductPageSkeleton = () => {
  return (
    <div className="styled-scroll mt-5 overflow-y-auto bg-linear-to-b from-[#FEFDFE] from-0% to-transparent to-100%">
      <div className="flex h-full flex-col overflow-hidden pb-[2%] lg:flex-row">
        <div className="hidden h-[40vh] basis-2/4 lg:block">
          <Skeleton className="h-full w-full" />
          <div className="mt-2 flex justify-between">
            <Skeleton className="aspect-square h-20 w-20" />
            <Skeleton className="aspect-square h-20 w-20" />
            <Skeleton className="aspect-square h-20 w-20" />
            <Skeleton className="aspect-square h-20 w-20" />
            <Skeleton className="aspect-square h-20 w-20" />
          </div>
        </div>
        <div className="block h-[40vh] basis-4/4 lg:hidden">
          <Skeleton className="h-full w-full" />
        </div>
        <div className="w-full flex-1 basis-2/4 items-start justify-start">
          <div
            id="product-info"
            className="bg-gradent-to-t flex h-full w-full flex-col gap-5 from-white from-50% to-violet-100 to-100% px-2 pt-2 lg:px-4 lg:pt-6"
          >
            <div id="product-card" className="flex h-fit max-h-fit w-full flex-col gap-3">
              <div className="flex w-full flex-row items-center justify-between">
                <Skeleton className="h-10 w-3/4" />
              </div>
              <div className="flex items-start justify-start gap-2">
                <Skeleton className="hidden h-6 w-full max-w-md lg:block" />
                <Skeleton className="h-6 w-20" />
              </div>
              <div className="flex gap-1">
                <Skeleton className="h-6 w-1/2" />
                <Skeleton className="h-6 w-1/4" />
              </div>
              <div className="flex items-center gap-2">
                <Skeleton className="h-10 w-1/2" />
                <Skeleton className="h-10 w-1/4" />
                <Skeleton className="h-10 w-1/4" />
              </div>
              <div className="flex flex-col gap-5 pt-4 pb-8">
                <Skeleton className="h-6 w-1/2" />
                <Skeleton className="h-10 w-full" />
              </div>
              <div
                className="border-primary-50/50 bg-primary-50/50 flex items-end gap-6 rounded-full border px-2 py-2 shadow-sm backdrop-blur-[25px] ltr:self-end rtl:self-start"
                dir="ltr"
              >
                <div className="flex items-center justify-center gap-1">
                  <Skeleton className="h-9 w-9 rounded-full" />
                  <Skeleton className="h-7 w-7 rounded-full" />
                  <Skeleton className="h-9 w-9 rounded-full" />
                </div>
              </div>
              <div className="flex items-center gap-3">
                <Skeleton className="h-12 w-full" />
              </div>
            </div>
            <div className="mt-5 h-full max-h-[310px] w-full flex-col gap-3 rounded-lg border border-[#ECE9FF] bg-white p-4 pb-6 shadow-sm backdrop-blur-[25px]">
              <Skeleton className="h-6 w-1/2" />
              <div className="my-3 flex flex-row items-start justify-start gap-4">
                <Skeleton className="h-24 w-24" />
                <div className="flex h-full basis-2/3 flex-col items-start justify-center gap-1">
                  <Skeleton className="h-6 w-1/2" />
                  <Skeleton className="h-6 w-1/3" />
                </div>
              </div>
              <Skeleton className="mb-1 h-6 w-1/2" />
              <Skeleton className="h-10 w-full" />
              <div className="w-full py-5 text-center">
                <Skeleton className="mx-auto h-6 w-1/2" />
              </div>
            </div>
            <div className="h-[70px] w-full">
              <Skeleton className="h-full w-full" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductPageSkeleton;
